import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Route } from '@angular/router';
import {
  SurveyResolver,
  UnifiedSurveyStore,
} from '@hyper-inferno/survey-elements-core-ui';

export const appRoutes: Route[] = [
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'survey-detail/:surveyId',
    loadComponent: () =>
      import('./pages//survey-detail/survey-detail.page').then(
        (m) => m.SurveyDetailPage,
      ),
  },
  // 1. Session Resume (Highest Priority)
  {
    path: 'session/:sessionId',
    loadComponent: () =>
      import('@hyper-inferno/survey-elements-core-ui').then(
        (m) => m.SurveyRenderMain,
      ),
    resolve: {
      surveyReady: (route: ActivatedRouteSnapshot) =>
        inject(SurveyResolver).resolve(route),
    },
  },
  // 2. Invitation Link (Unique per user)
  {
    path: 'invitation/:invitationId',
    loadComponent: () =>
      import('@hyper-inferno/survey-elements-core-ui').then(
        (m) => m.SurveyRenderMain,
      ),
    resolve: {
      surveyReady: (route: ActivatedRouteSnapshot) =>
        inject(SurveyResolver).resolve(route),
    },
  },
  // 3. Open Link (Self-Serve)
  {
    path: 'self-serve/:surveyId',
    loadComponent: () =>
      import('@hyper-inferno/survey-elements-core-ui').then(
        (m) => m.SurveyRenderMain,
      ),
    resolve: {
      surveyReady: (route: ActivatedRouteSnapshot) =>
        inject(SurveyResolver).resolve(route),
    },
    canDeactivate: [
      () => {
        // Inject your store service and trigger cache cleanup
        const store = inject(UnifiedSurveyStore);
        store.clearStore(); // Replace with your store's clear/reset method
        return true; // Allow navigation to proceed
      },
    ],
  },
  // 4. State/Error Pages
  {
    path: 'offline-notice',
    loadComponent: () =>
      import('@hyper-inferno/survey-elements-core-ui').then(
        (m) => m.SurveyOffline,
      ),
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('@hyper-inferno/survey-elements-core-ui').then(
        (m) => m.SurveyNotFound,
      ),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/sign-up/sign-up').then((m) => m.SignUp),
  },
  // 5. Wildcards
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: '**', redirectTo: 'not-found' },
];

// survey.resolver.ts

// import { UnifiedSurveyStore } from './unified-survey.store';
// import { OfflineSurveyDb } from './offline-db.service';
